// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3NOwt","approved":"Status_approved__1Ro7M","rejected":"Status_rejected__2KQ3F","expired":"Status_expired__3-hvW","label":"Status_label__3XZp7"};